import type { Filter } from '@cubejs-client/core'
import {
  CONVERSATION_FACTS_DIMENSIONS,
  CONVERSATION_FACTS_ZONE_DIMENSIONS,
  DRIFT_CHAT_TAGS_DIMENSIONS,
} from 'cube'
import { Moment } from 'moment'

import { type CubeQuery, CubeQueryBuilder } from '@driftt/dds.reports'

import { ConversationTagsBaseQuery } from './ConversationTagsBaseQuery.query'

export const formatConversationTagDrillDownQuery = (
  tagName: string,
  startDate: Moment,
  endDate: Moment,
  filters: Filter[]
): CubeQuery => {
  return new CubeQueryBuilder({})
    .withName(`ConversationTagDrillDown-${tagName}`)
    .withQueryName(`ConversationTagDrillDown-${tagName}`)
    .withDimensions([
      CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CREATED_AT,
      CONVERSATION_FACTS_DIMENSIONS.DURATION_BETWEEN_FIRST_INTERACTION_AND_FIRST_CLOSE_MS,
      DRIFT_CHAT_TAGS_DIMENSIONS.TAG_NAME,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_ID,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_STATUS,
    ])
    .withFilters([
      {
        member: DRIFT_CHAT_TAGS_DIMENSIONS.TAG_NAME,
        operator: 'equals',
        values: [tagName],
      },
      ...filters,
    ])
    .withinDateRange(
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_CREATED_AT,
      startDate.toDate(),
      endDate.toDate()
    )
    .withOrder([
      [CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CREATED_AT, 'desc'],
    ])
    .build()
}

export const formatConversationTagsExportQuery = (
  startDate: Moment,
  endDate: Moment,
  filters: Filter[]
): CubeQuery => {
  return new CubeQueryBuilder({ query: ConversationTagsBaseQuery })
    .withName(`ConversationTagsExport`)
    .withQueryName(`ConversationTagsExport`)
    .withinDateRange(
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_CREATED_AT,
      startDate.toDate(),
      endDate.toDate()
    )
    .withFilters([
      {
        member: DRIFT_CHAT_TAGS_DIMENSIONS.TAG_NAME,
        operator: 'set',
      },
      ...filters,
    ])
    .build()
}
